import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import FileUpload from './FileUpload';
import Dashboard from './Dashboard';
import Login from './Login';
import PrivateRoute from './PrivateRoute';
import Reports from './Reports';
import NetworkManagement from './NetworkManagement';
import CallManagement from './CallManagement';
import PerformanceReports from './PerformanceReports';
import UserManagement from './UserManagement';
import ManualAllocation from './ManualAllocation';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    if (storedUser && token) {
      setUser(JSON.parse(storedUser));
    }

    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <Router>
      <div className="app">
        {user && (
          <nav className={`nav ${scrolled ? 'nav-scrolled' : ''}`}>
            <div className="nav-container">
              <div className="nav-brand">
                <img 
                  src="/logo.png" 
                  alt="RV Solutions" 
                  className="nav-logo-image"
                  style={{
                    height: '45px',
                    width: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              <div className="nav-links">
                <Link to="/" className="nav-link">Upload</Link>
                <Link to="/dashboard" className="nav-link">Dashboard</Link>
                <Link to="/reports" className="nav-link">Reports</Link>
                <Link to="/network" className="nav-link">Network</Link>
                <Link to="/calls" className="nav-link">Call Management</Link>
                <Link to="/performance" className="nav-link">Performance</Link>
                {user?.role === 'Admin' && (
                  <Link to="/users" className="nav-link">Users</Link>
                )}
                <Link to="/manual" className="nav-link">Manual Allocation</Link>
                
                <div className="nav-user">
                  <span className="user-name">{user.name}</span>
                  <span className="user-role">{user.role}</span>
                  <button onClick={handleLogout} className="logout-button">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                      <polyline points="16 17 21 12 16 7" />
                      <line x1="21" y1="12" x2="9" y2="12" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </nav>
        )}

        <main className="main-content">
          <Routes>
            <Route path="/login" element={
              user ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />
            } />
            
            <Route path="/" element={
              <PrivateRoute>
                <FileUpload />
              </PrivateRoute>
            } />
            
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />
    
            <Route path="/reports" element={
              <PrivateRoute>
                <Reports />
              </PrivateRoute>
            } />

            <Route path="/network" element={
              <PrivateRoute>
                <NetworkManagement />
              </PrivateRoute>
            } />

            <Route path="/calls" element={
              <PrivateRoute>
                <CallManagement />
              </PrivateRoute>
            } />

            <Route path="/performance" element={
              <PrivateRoute>
                <PerformanceReports />
              </PrivateRoute>
            } />

            <Route path="/users" element={
              <PrivateRoute allowedRoles={['Admin']}>
                <UserManagement />
              </PrivateRoute>
            } />

            <Route path="/manual" element={
              <PrivateRoute>
                <ManualAllocation />
              </PrivateRoute>
            } />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;